/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_DisabledInputs */

const vi_einvoice_settings_disabled = /** @type {(inputs: Einvoice_Settings_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt`)
};

/**

* @param {Einvoice_Settings_DisabledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_disabled = /** @type {((inputs?: Einvoice_Settings_DisabledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_DisabledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_disabled(inputs)
});